export default __webpack_public_path__ + "static/media/Hair_20_F_C3.050bf9bd.svg";